










































































import Vue from "vue";
import {Component} from "vue-property-decorator";
import SectionHeader from "@/components/SectionHeader.vue";
import KeyValue from "@/components/KeyValue.vue";
import VueError from "@/components/VueError.vue";
import Success from "@/components/Success.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import Loading from "@/components/Loading.vue";
import LocationMovementsHistoryTable from "@/components/ntag/LocationMovementsHistoryTable.vue";
import {BaseStationLocation, NTagLocation} from "@/types/ntag";
import {curNtagClient, NtagClient} from "@/services/NtagClient";
import LocationTagsList from "@/components/ntag/LocationTagsList.vue";
import EditableInput from "@/components/EditableInput.vue";
import BaseStationsList from "@/components/ntag/BaseStationsList.vue";
import {Location} from "@/types/core";
import {getCenter} from "geolib";
import * as _ from "lodash";
import {GeolibInputCoordinates} from "geolib/es/types";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";

@Component({
  components: {
    BaseStationsList,
    LocationTagsList,
    SectionHeader,
    KeyValue,
    EditableInput,
    VueError,
    Success,
    TimestampAgo,
    Loading,
    LocationMovementsHistoryTable,
    ConfirmDialog,
  },
})
export default class NtagLocationPage extends Vue {
  location:NTagLocation = {} as NTagLocation;

  httpBusyTag:boolean = false;
  httpBusyReadings:boolean = false;

  error:string = '';
  locationNameHttpError:string = '';
  locationNameWaiting:boolean = false;
  editLocationName = false;

  hideLocationDisabled:boolean = true;

  centralLocation: Location | undefined = {} as Location;

  gmapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    zoom: 10,
  };

  gmapMarkerOptions = {
    opacity: 0.5,
  };

  // internal dependencies
  private ntagClient:NtagClient = curNtagClient;

  async mounted() {
    await this.refreshStatus();
  }

  async onHideLocationClick() {
    (this.$refs.confirmHideLocation as ConfirmDialog).show(this.hideLocation);
  }

  async hideLocation() {
    const putReply = await this.ntagClient.hideLocation(this.location.id);

    if(putReply.errorMsg){
      this.error = `Unable to hide location: ${putReply.errorMsg}`;
      return;
    }

    setTimeout(() => {  this.navigateTo('locations-list'); }, 1000);
  }

  async refreshStatus() {
    await this.getLocation();
  }

  async getLocation() {
    this.httpBusyTag = true;

    const reply = await this.ntagClient.getLocation(this.$route.params.locationId);

    this.httpBusyTag = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg) {
      return this.error = `Unable to retrieve tag ${this.$route.params.locationId}: ${reply.errorMsg}`;
    }

    this.location = reply.location!;

    if (this.location.bssIdsList.length === 0) {
      this.hideLocationDisabled = false;
    }
    this.centralLocation = this.getCentralLocation();
  }

  getCoords() {
    const coordinates = _.map(this.location.bssGeoLocations, (item) => {
      const coord:GeolibInputCoordinates = this.getGeoPosition(item);
      return coord;
    });

    return coordinates;
  }

  getCentralLocation():Location | undefined {
    const coordinates = this.getCoords();
    const center: false | {
      longitude: number;
      latitude: number;
    } = getCenter(coordinates);
    if ( center ) {
      const centerLocation: Location = {
        type: "network",
        latitude: center.latitude,
        longitude: center.longitude,
      }
      return centerLocation;
    }
    return undefined;
  }

  getBaseStationLabel(index: number): string {
    const bssId = this.location.bssIdsList[index];
    return `${bssId!.charAt(0)}..${bssId!.charAt(bssId!.length-1)}`;
  }

  getGeoPosition(bssGeoLocation: BaseStationLocation): GeolibInputCoordinates {
    return {
      lat: bssGeoLocation.lat,
      lng: bssGeoLocation.long,
    };
  }

  get showLocation():boolean {
    return !this.httpBusyTag && this.location !== undefined;
  }

  get statusTopIconList():object[] {

    return [
      {name:'arrow-left', title:'back to locations list', event:'locations-list'},
      {name:'eye-slash', title: 'hide location', event: 'hide-location', disabled: this.hideLocationDisabled},
      {name:'sync-alt', title:'reload status', event:'refresh-status'},
    ];
  }

  navigateTo(dest:'locations-list') {
    switch(dest) {
      case 'locations-list': this.$router.push({ name: 'applications-ntag-locations'}); break;
    }
  }

  async updateLocationName(newLocationName:string) {
    this.locationNameHttpError = '';
    this.locationNameWaiting = true;
    const putReply = await this.ntagClient.updateLocationName(this.location.id, newLocationName);

    this.locationNameWaiting = false;

    if(putReply.errorMsg){
      this.locationNameHttpError = `Unable to update: ${putReply.errorMsg}`;
      this.editLocationName = true;
      return;
    }

    this.location.name = newLocationName;
  }
}
